import React from 'react';
import { Skeleton } from '../../../../../components/ui/skeleton';
import { TableCell, TableRow } from '../../../../../components/ui/table';

function FileListItemSkeleton() {
  return (
    <TableRow
      data-testid="file-list-skeleton"
      className="border-b border-border/30 hover:bg-transparent"
    >
      {/* Name Column - matches FileListItemShell structure */}
      <TableCell className="py-4 px-4">
        <div className="flex items-center gap-3 min-w-0">
          {/* Thumbnail - matches exact size from shell (h-9 w-9) */}
          <Skeleton className="h-9 w-9 rounded flex-shrink-0" />

          {/* Title and Metadata - matches FileListItemShell gap-1 structure */}
          <div className="flex flex-col gap-1 min-w-0 flex-1">
            {/* Title - matches text-sm font-medium */}
            <Skeleton className="h-3.5 w-48 max-w-full" />

            {/* Metadata row - matches text-xs */}
            <Skeleton className="h-3 w-32 max-w-full" />
          </div>
        </div>
      </TableCell>

      {/* Date Column - matches FileListItemShell w-32 */}
      <TableCell className="py-4 px-4 w-32">
        <Skeleton className="h-3.5 w-24" />
      </TableCell>

      {/* Action Menu Column - matches FileListItemShell w-10 */}
      <TableCell className="py-4 w-10">
        <div className="flex justify-end">
          <Skeleton className="h-6 w-6 rounded opacity-0" />
        </div>
      </TableCell>
    </TableRow>
  );
}

export default FileListItemSkeleton;
